import type { EthereumAddress, } from "@bracket/sharedTypes";


/** the block chain address of a token */
export declare type TokenAddress = EthereumAddress & { };

/** check if a string is a valid token address */
export const isTokenAddress = (value: unknown): value is TokenAddress =>
  typeof value === "string" && value.length === 42 && /^0x[0-9a-fA-F]+$/.test(value);
